export enum Brand {
    AUDI = 'Audi',
    SEAT = 'SEAT',
    SKODA = 'ŠKODA',
    VW = 'Volkswagen',
}
